import React from 'react';
import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet';

const Menu = () => {
  const menuImages = [
    'https://i.ibb.co/ym4jBYcs/Menu.jpg',
    'https://i.ibb.co/7dsXn1p3/Menu-1.jpg',
    'https://i.ibb.co/XfhgDMMS/Menu-1.png',
    'https://i.ibb.co/prvVV15g/Menu-7.jpg',
    'https://i.ibb.co/5xghtw7Q/Menu-8.jpg',
    'https://i.ibb.co/YF5MyDsv/Menu-9.jpg',
    'https://i.ibb.co/5WNS5Dcn/Menu-10.jpg',
    'https://i.ibb.co/v4RbLq9S/Menu-11.jpg',
    'https://i.ibb.co/yFcFBbbw/Menu-12.jpg',
    'https://i.ibb.co/JjB8pT0m/Menu-13.jpg',
    'https://i.ibb.co/ksgDjxLW/Menu-14.jpg',
    'https://i.ibb.co/BVgPXvyv/Menu-15.jpg'
  ];

  return (
    <>
      <Helmet>
        <title>Menu - Zalabya | Egyptian Desserts Menu</title>
        <meta name="description" content="Explore our complete menu of authentic Egyptian desserts including zalabya, Dubai chocolate, strawberry cups and more at Zalabya Mississauga." />
      </Helmet>

      <div className="pt-24 pb-12">
        <div className="container mx-auto px-4">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center mb-12"
          >
            <h1 className="text-5xl font-bold text-gradient mb-4">Our Menu</h1>
            <p className="text-xl text-gray-300 max-w-2xl mx-auto">
              Discover our authentic Egyptian desserts, from traditional zalabya to modern Dubai chocolate creations
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {menuImages.map((image, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className="card overflow-hidden"
              >
                <img
                  src={image}
                  alt={`Menu Page ${index + 1}`}
                  className="w-full h-auto object-cover hover:scale-105 transition-transform duration-300"
                />
              </motion.div>
            ))}
          </div>

          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center mt-12"
          >
            <h2 className="text-3xl font-bold text-yellow-400 mb-6">Ready to Order?</h2>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a href="tel:+19058207700" className="btn-primary">
                Call to Order: (905) 820-7700
              </a>
              <a href="https://wa.me/16475370181" className="btn-secondary" target="_blank" rel="noopener noreferrer">
                WhatsApp: (647) 537-0181
              </a>
            </div>
          </motion.div>
        </div>
      </div>
    </>
  );
};

export default Menu;